import { slugify } from "@/lib/utils";

const TABLE_ROW_RE = /^\s*\|.*\|\s*$/;
const TABLE_DELIM_RE = /^\s*\|?[\s:-]*-[\s:|-]*\|\s*$/;
const HEADING_RE = /^(#{1,6})\s+(.*)$/;
const BOLD_HEAD_RE = /^\*\*(.+?)\*\*\s*:?\s*$/;

export function extractMarkdownTables(content) {
  const lines = String(content || "").split("\n");
  const tables = [];
  let lastHeading = null;
  let i = 0;
  while (i < lines.length) {
    const stripped = lines[i].trim();
    const heading = stripped.match(HEADING_RE);
    const bold = stripped.match(BOLD_HEAD_RE);
    if (heading) {
      lastHeading = heading[2].trim();
      i += 1;
      continue;
    }
    if (bold) {
      lastHeading = bold[1].trim();
      i += 1;
      continue;
    }
    if (TABLE_ROW_RE.test(stripped) && i + 1 < lines.length && TABLE_DELIM_RE.test(lines[i + 1].trim())) {
      i += 2;
      while (i < lines.length && TABLE_ROW_RE.test(lines[i].trim())) i += 1;
      tables.push({ title: lastHeading || `Tabela ${tables.length + 1}` });
      lastHeading = null;
      continue;
    }
    i += 1;
  }
  return tables;
}

export function tableCount(content) {
  return extractMarkdownTables(content).length;
}

export function workingView(artifact, working = true) {
  if (!artifact) return null;
  const rev = working ? artifact.revision : null;
  if (rev && (rev.content || rev.title)) {
    return {
      ...artifact,
      title: rev.title || artifact.title,
      content: rev.content != null ? rev.content : artifact.content,
      model: rev.model != null ? rev.model : artifact.model,
    };
  }
  return artifact;
}

// Relatório já salvo com ajuste pendente: "Salvar ajustes" publica a revisão sem passar pelo chat.
export function isSavedWithRevision(artifact) {
  return Boolean(artifact && artifact.status === "saved" && artifact.revision?.content);
}

// Só vale se o backend não mandar Content-Disposition; espelha pdf_filename do backend.
export function pdfFallbackName(artifact) {
  const slug = slugify(artifact?.title);
  return artifact?.type === "pricing" ? `${slug}.pdf` : `roteiro-${slug}.pdf`;
}

export function hasLivePricing(artifact) {
  if (!artifact || artifact.type !== "pricing") return false;
  const model = artifact.model;
  return Boolean(model && (model.result || model.inputs));
}

export function showTablesBar(artifact, working = true) {
  const view = workingView(artifact, working);
  if (!view) return false;
  return tableCount(view.content) > 0 || hasLivePricing(view);
}
